<template>

	<li class="c-card-publication " :id="card.id">

		<div class="c-card-publication__dossier c-tag">
           <span v-html="card.region"></span>
            <span class="c-tag--file">PDF</span>
        </div>

		<div class="c-card-publication__title">
			<h2 class="h6" v-html="card.name"></h2>
		</div>

		<div class="c-card-publication__municipalities" v-html="municipalities"></div>

		<div v-if="card.file.url" class="c-card-publication__bottom">
			<a class="c-card-publication__file c-card-publication__file--regions" :href="card.file.url">
                <span>Download rapportage</span>
                <svg class="icon icon-icon_download"><use xlink:href="#icon-icon_download"></use></svg>
            </a>
		</div>
	</li>

</template>

<script>
export default {
	name: 'Region',
	props: {
		card: Object,
		searchTerm: String
	},
	data() {
		return {
			collapsed: true,
		}
	},
	computed: {
		municipalities() {
			const municipalitiesStr = this.card.municipalities.join(', ');
			const result = municipalitiesStr.replace(this.searchTerm, `<span class="search-term">${this.searchTerm}</span>`);
			return result;
		},
	},
};
</script>

<style lang="scss" scoped></style>
